export default __webpack_public_path__ + "static/media/user_failed_get_data.ff11cfa3.svg";